import { useEffect, useState, Fragment, useCallback } from 'react';
import { Row, Col, Button, Spin, Tooltip } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import moment from 'moment-timezone';
import { getReservations, getReservationServices } from '../../services/reservation';
import * as _ from 'lodash';
import { getCookie } from './../../services/cookies';
import { useTranslation } from "react-i18next";

const ReservationWebPage = () => {
  const [loading, setLoading] = useState({
    webReservations: false,
    services: false,
  });
  const [webReservations, setWebReservations] = useState();
  const [reservationServices, setReservationServices] = useState();
  const location = useLocation();
  const cookieBranchOfficeId = getCookie("branch_office_id");
  const { t } = useTranslation();

  const fetchWebReservations = useCallback(async () => {
    if (cookieBranchOfficeId) {
      setLoading(loading => { return { ...loading, webReservations: true } });
      const response = await getReservations({ type: 'web' }, cookieBranchOfficeId);
      setWebReservations(response.data);
      setLoading(loading => { return { ...loading, webReservations: false } });
    }
  }, []);

  useEffect(() => {
    fetchWebReservations();
  }, [fetchWebReservations]);

  const fetchReservationServices = async (reservationId) => {
    if (cookieBranchOfficeId) {
      setLoading({ ...loading, services: true });
      const response = await getReservationServices({ id: reservationId }, cookieBranchOfficeId);
      const orderByBlock = _.orderBy(response, 'block');
      setReservationServices(orderByBlock);
      setLoading({ ...loading, services: false });
    }
  };

  const formatDate = (date) => {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
  };

  const createdAgo = (date, timezone) => {
    if (date && timezone) {
      const startTime = moment.tz(date, 'UTC');
      const newStartTime = moment(startTime.format('YYYY-MM-DD HH:mm:ss'));
      const currentTime = moment().tz(timezone);
      const duration = moment.duration(currentTime.diff(startTime));
      const days = parseInt(duration.asDays());
      const hours = parseInt(duration.asHours());

      return (
        <p className={`text-center mb-0 ${(days > 0 || hours >= 1) && 'warning-text'}`}>
          {newStartTime.fromNow()}
        </p>
      )
    }
  };

  return (
    <Row justify="center" className="reservation-web-wrapper mb-20">
      <Col lg={24} xs={24}>
        <Row justify="center">
          <Col
            lg={24}
            xs={24}
            className="reservation-web-wrapper__header pt-20"
          >
            <Row justify="center">
              <Col lg={22} xs={22}>
                <Row justify="space-between">
                  <Col className="back-button-wrapper">
                    <Link to="/reservas/buscar">
                      <i className="icon-system-chevron-left" />
                      Volver
                    </Link>
                  </Col>
                  <Col>
                    <Button
                      className="cmt-button primary outline"
                      type="primary"
                      disabled
                    >
                      <svg
                        className="mr-15"
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 35.622 36.587"
                      >
                        <g
                          id="Grupo_754"
                          data-name="Grupo 754"
                          transform="translate(-596.378 -1621.284)"
                        >
                          <path
                            id="Trazado_82"
                            data-name="Trazado 82"
                            d="M1465.237,496.958v1.216a3.987,3.987,0,1,1-7.974,0v-1.216h-7.156v1.216a3.988,3.988,0,1,1-7.975,0v-1.216h-6.258v29.811H1471.5V496.958Z"
                            transform="translate(-839.496 1131.102)"
                            fill="#dc582a"
                          />
                          <path
                            id="Trazado_83"
                            data-name="Trazado 83"
                            d="M1452.976,493.49a1.284,1.284,0,1,1-2.569,0v-6.3a1.284,1.284,0,1,1,2.569,0Z"
                            transform="translate(-845.118 1135.376)"
                            fill="#dc582a"
                          />
                          <path
                            id="Trazado_84"
                            data-name="Trazado 84"
                            d="M1477.637,493.49a1.284,1.284,0,1,1-2.568,0v-6.3a1.284,1.284,0,1,1,2.568,0Z"
                            transform="translate(-854.657 1135.376)"
                            fill="#dc582a"
                          />
                        </g>
                      </svg>
                      {t('reservations.webReservations.webReservationsButton')}
                    </Button>
                  </Col>
                  <Col lg={24} xs={24}>
                    <h1 className="text-center mb-10">
                      {t('reservations.webReservations.title')}
                    </h1>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
          {loading.webReservations ? (
            <Spin className="custom-spinner margin-top" />
          ) : (
            webReservations && (
              <Col
                lg={22}
                xs={23}
                className="reservation-web-wrapper__body mt-lg-60 mt-md-40 mt-sm-40 mt-xs-40"
              >
                <Row className="table-header">
                  <Col lg={3}>
                    <p className="mb-5 ml-15">
                      {t('reservations.webReservations.reservationNumber')}
                    </p>
                  </Col>
                  <Col lg={4}>
                    <p className="text-center mb-5">
                      {t('reservations.webReservations.companyTitle')}
                    </p>
                  </Col>
                  <Col lg={4}>
                    <p className="text-center mb-5">
                      {t('reservations.webReservations.branchOfficeTitle')}
                    </p>
                  </Col>
                  <Col lg={3}>
                    <p className="text-center mb-5">
                      {t('reservations.webReservations.servicesTitle')}
                    </p>
                  </Col>
                  <Col lg={3}>
                    <p className="text-center mb-5">
                      {t('reservations.webReservations.dateTitle')}
                    </p>
                  </Col>
                  <Col lg={5}>
                    <p className="text-center mb-5">
                      {t('reservations.webReservations.creationTitle')}
                    </p>
                  </Col>
                  <Col lg={2}></Col>
                </Row>
                {webReservations.map((reservation, index) => {
                  return (
                    <Row
                      className="table-body mb-lg-10 mb-md-15 mb-sm-15 mb-xs-15"
                      key={index}
                    >
                      <Col className="table-body__item" lg={3} xs={12}>
                        <p className="mobile-title text-center">
                          {t('reservations.webReservations.reservationNumber')}
                        </p>
                          <p className="mb-0 ml-lg-15">{reservation.number}</p>
                      </Col>
                      <Col className="table-body__item" lg={4} xs={12}>
                        <p className="mobile-title text-center">
                          {t('reservations.webReservations.companyTitle')}
                        </p>
                        <p className="text-center mb-0">
                          {reservation.company
                            ? reservation.company.business_name
                            : ""}
                        </p>
                      </Col>
                      <Col className="table-body__item" lg={4} xs={12}>
                        <p className="mobile-title text-center">
                          {t('reservations.webReservations.branchOfficeTitle')}
                        </p>
                        <p className="text-center mb-0">
                          {reservation.branch_office.name}
                        </p>
                      </Col>
                      <Col className="table-body__item" lg={3} xs={12}>
                        <Tooltip
                          overlayClassName='see-services-tooltip'
                          trigger="click"
                          onClick={() =>
                            fetchReservationServices(reservation.id)
                          }
                          color="#FFFFFF"
                          title={
                            <Fragment>
                              <Row justify="space-between">
                                <Col lg={12}>
                                  <p className="title mb-10">
                                    {t('reservations.webReservations.serviceTooltip')}
                                  </p>
                                </Col>
                                <Col lg={6}>
                                  <p className="title text-center mb-10">
                                    {t('reservations.webReservations.workersTooltip')}
                                  </p>
                                </Col>
                                <Col lg={6}>
                                  <p className="title text-center mb-10">
                                    {t('reservations.webReservations.blockTooltip')}
                                  </p>
                                </Col>
                              </Row>
                              {loading.services && !reservationServices ? (
                                <Row justify="center">
                                  <Spin className="custom-spinner" />
                                </Row>
                              ) : (
                                <Fragment>
                                  {reservationServices &&
                                    reservationServices.map(
                                      (service, index) => {
                                        return (
                                          <Row
                                            justify="space-between"
                                            key={index}
                                          >
                                            <Col lg={12}>
                                              <p>{service.name}</p>
                                            </Col>
                                            <Col lg={6}>
                                              <p className="text-center">
                                                {service.total_patients}
                                              </p>
                                            </Col>
                                            <Col lg={6}>
                                              <p className="text-center">
                                                {service.block}hs
                                              </p>
                                            </Col>
                                          </Row>
                                        );
                                      }
                                    )}
                                </Fragment>
                              )}
                            </Fragment>
                          }
                        >
                          <p className="mobile-title text-center">
                            {t('reservations.webReservations.servicesTitle')}
                          </p>
                          <p
                            className="text-center mb-0"
                            style={{ cursor: "pointer" }}
                          >
                            Ver {t('reservations.webReservations.servicesTitle').toLocaleLowerCase()}
                          </p>
                        </Tooltip>
                      </Col>
                      <Col className="table-body__item" lg={3} xs={12}>
                        <p className="mobile-title text-center">
                          {t('reservations.webReservations.dateTitle')}
                        </p>
                        <p className="text-center mb-0">
                          {formatDate(reservation.reservation_date)}
                        </p>
                      </Col>
                      <Col className="table-body__item" lg={5} xs={12}>
                        <p className="mobile-title text-center">
                          {t('reservations.webReservations.creationTitle')}
                        </p>
                          {createdAgo(reservation.created_at, reservation.timezone)}
                      </Col>
                      <Col
                        className="table-body__item button-wrapper"
                        lg={2}
                        xs={24}
                      >
                        <Link
                          to={{
                            pathname: `/reservas/${reservation.id}/editar`,
                            state: {
                              from: location.pathname,
                              search: location.search,
                            },
                          }}
                          style={{
                            width: "80%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            className="cmt-button secondary outline"
                            type="primary"
                            size="small"
                          >
                            Ver más
                          </Button>
                        </Link>
                      </Col>
                    </Row>
                  );
                })}
              </Col>
            )
          )}
        </Row>
      </Col>
    </Row>
  );
};

export default ReservationWebPage;
